'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var initAction = { type: '@@multireducer/INIT' };

exports.default = initAction;


//////////////////
// WEBPACK FOOTER
// ./node_modules/multireducer/lib/initAction.js
// module id = 281
// module chunks = 21